export default "__VITE_ASSET__DLOk1Ffk__"